export default __webpack_public_path__ + "static/media/Legal_mention.6242633d.svg";